export default {
  GET_DEPARTURE_CITIES_BEGIN: 'tours/searchForm/GET_DEPARTURE_CITIES',
  GET_DEPARTURE_CITIES_FAIL: 'tours/searchForm/GET_DEPARTURE_CITIES_FAIL',
  GET_DEPARTURE_CITIES_SUCCESS: 'tours/searchForm/GET_DEPARTURE_CITIES_SUCCESS',

  SET_DEPARTURE_QUERY: 'tours/searchForm/SET_DEPARTURE_QUERY',
};
